import { render, staticRenderFns } from "./AdminAction.vue?vue&type=template&id=5af1c4b4&"
import script from "./AdminAction.vue?vue&type=script&lang=js&"
export * from "./AdminAction.vue?vue&type=script&lang=js&"
import style0 from "./AdminAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports